/* eslint-disable no-loop-func */
import * as types from './types';
/* eslint-disable import/no-cycle */
import campaignMatchesApi from '../api/campaignMatchesApi';
import annotationsApi from '@/modules/campaignMatches/api/annotationsApi';

const actions = {
  [types.FETCH_DAILY_MATCHES]: (context, campaignId) => campaignMatchesApi.getDailyMatches(campaignId).then((response) => response),
  [types.FETCH_BRANDSAFETY_CLASSIFIERS]: () => annotationsApi.getBrandSafetyClassifiers().then((response) => response.corpusConfiguration.labels),
  [types.UPDATE_BRANDSAFETY_CLASSIFIERS]: (context, payload) => annotationsApi.updateAnnotations({
    author: `${context.rootState.account.firstName.toLowerCase()}.${context.rootState.account.lastName.toLowerCase()}`,
    corpus: 'brandsafety',
    label: payload.labels,
    advId: payload.advertiserContentExternalId,
    pubId: payload.publisherContentExternalId,
  }).then((response) => response),
  [types.UPDATE_MATCHES]: (context, payload) => annotationsApi.updateAnnotations({
    author: `${context.rootState.account.firstName.toLowerCase()}.${context.rootState.account.lastName.toLowerCase()}`,
    corpus: 'MATCHES',
    label: payload.label,
    advId: payload.advertiserContentExternalId,
    pubId: payload.publisherContentExternalId,
  }).then((response) => response),
};
export default actions;
